import axios from "axios";
// const baseURL = "http://192.168.14.35:9080/v1"; // Development server URL
const baseURL = "http://117.72.173.214:9080/v1"; // Production server URL
// const baseURL = "https://xster.cn/api"; // Public server URL
const instance = axios.create({
    baseURL: baseURL,
    timeout: 10000, // Set a timeout of 10 seconds
});

instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

instance.interceptors.request.use(
    config => {
        config.h
        // Add Bearer jwtToken if needed
        const jwtToken = localStorage.getItem('jwtToken');
        if (jwtToken) {
            config.headers['Authorization'] = `Bearer ${jwtToken}`;
        }
        return config;
    },
    error => {
        // Handle request error
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => {
        // Handle successful response
        return response; // Return only the data part of the response
    },
    error => {
        // Handle response error
        if (error.response) {
            // The request was made and the server responded with a status code
            console.error("Error response:", error.response.data);
        } else if (error.request) {
            // The request was made but no response was received
            console.error("No response received:", error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error("Request error:", error.message);
        }
        return Promise.reject(error);
    }
);  

export default instance;